import React from 'react';
import './Footer.css';
import SocialIcons from '../../cards/SocialIcons';
import img from "../../../assets/img/img1.jpg";

export default function Footer() {
  return (
    <footer className="site-footer py-5">
      <div className="container">
        <div className="row">
          {/* من نحن */}
          <div className="col-md-4 mb-4">
            <h5 className="text-white fw-bold mb-3">من نحن</h5>
            <p className="text-light small">
              نقدم تغطية إخبارية شاملة وموثوقة من قلب الحدث، على مدار الساعة، بأقلام صحفية محترفة.
              تابع آخر الأخبار السياسية، الاقتصادية، والإنسانية من العالم العربي والعالم.
            </p>
 <h5 className="text-white fw-bold mt-5 mb-3">الرسالة</h5>
            <p className="text-light small">
              نحن في شبكة الصحافة والإعلام الفلسطينية نؤمن بأن الإعلام ليس فقط ناقلًا للحدث، بل صانعًا للوعي.
              نُنتج محتوى إخباريًا وتحليليًا يعكس الهوية الفلسطينية وتنوعها، ويصل إلى جمهورنا داخل فلسطين وفي الشتات، وإلى الرأي العام الإقليمي والدولي.
              نعمل على تغطية الأحداث بدقة ومهنية وشفافية، ونستخدم وسائط متعددة وتقنيات رقمية حديثة لنقل الخبر، القصة، والتحليل، بلغة مسؤولة وواعية، تُخاطب الإنسان والعقل والمستقبل.
            </p>
            
          </div>

          {/* الرؤية والرسالة */}
          <div className="col-md-4 mb-4 vision-mission">
            <h5 className="text-white fw-bold mb-3">الرؤية</h5>
            <p className="text-light small">
              أن نكون منصة إعلامية فلسطينية رائدة، تمتلك الأدوات الحديثة، والرؤية المهنية، والقدرة على نقل الحقيقة الفلسطينية إلى العالم، وتقديم إعلامٍ مسؤول يُعبّر عن واقع الإنسان الفلسطيني وتطلعاته، بمنهجية دقيقة ومحتوى يعزز الوعي والمصداقية.
            </p>

           
            <img className='mt-5 sm-text-center me-4' src={img} style={{ width: 300, height: 150 }}/>
            
            
          </div>

          <div className="col-md-4 mb-4">
            <h5 className="text-white fw-bold mb-3 pe-2">تواصل معنا</h5>
            <SocialIcons />

            {/* <h6 className="text-white fw-bold mt-4 pe-2">شركاؤنا:</h6>
            <div className="partners-logos mt-2">
              <div className="partner-box">+</div>
              <div className="partner-box">+</div>
              <div className="partner-box">+</div>
            </div>
             */}
          </div>
        </div>
      </div>
    </footer>
  );
}
